import RowAdder from './RowAdder';
import { VerticalTranslationContext } from './Contexts';
import { useEffect, useContext, useMemo } from 'react';


export default function ColumnHeaderRow({
  editable,tableOutlineShowing,cols,gelBounds,
  figurePanelId,
}){




  const verticalImageResizeTranslation = useContext(VerticalTranslationContext);


  
  //there is no real reason that I can think of
  //that his component
  // is made in 2 different rows.
  // but who cares I'm not editing this now.



  let style = {}
  let yTrans = verticalImageResizeTranslation?.y;
  if( yTrans ){
    if( yTrans < 0 ){
      style.transform = 'translate(0,'+verticalImageResizeTranslation?.y+'px)'
    }else{
      style.height = yTrans;
    }
  }

  style = { transform:'translate(0,'+verticalImageResizeTranslation?.y+'px)' }



  let cellHeaders = useMemo(() => (
    <tr style={style}>
      <td/>
      { Array(cols).fill("").map((_,ii) =>{
        return (
          <td style={{
            textAlign:'center',position:'relative',
            color:(tableOutlineShowing ?'#ccc' : 'white')}}>
            {ii > 0 && <div 
              style={{top:-20,position:'absolute', height:25,zIndex:3,width:'100%',
                //border:'1px solid black'
              }}>
              {ii > 0 ? (ii) : ""}
            </div>}
          </td>
        )})}
      <td></td>
    </tr>
  ),[tableOutlineShowing,cols,style])


  let cellAdders = useMemo(() => (<tr 
    style={style}>
    <td></td>
    {
      Array(cols).fill("").map((_,ii) =>{
        return (
          <td style={{
            textAlign:'center',position:'relative',
            color:(tableOutlineShowing ?'#aaa' : 'white')}}>
            


            <div 
              class={ii===5 ? 'place-to-add-column' : ''}
              style={{left:-10,top:-25,position:'absolute', 
                height:25,
                zIndex:3,
              }}>

              <RowAdder {...{alwaysVisible:tableOutlineShowing}}
                tooltip={"Add Column Here"}
                tooltipPlacement={"top"}
                figurePanelId={figurePanelId} level={'top'} columnIndex={ii}
              />
            </div>





          </td>
        )
      })
    }
    <td></td>
  </tr>),[tableOutlineShowing,cols,figurePanelId,style])


  
  if( !editable ){
    return null;
  }

  return [
    cellHeaders,
    cellAdders
  ];
                  
}
